
import { Cookies } from 'quasar'

const partnerDataKey = 'partnerDataKey'

const cookiesOptions = { domain: process.env.COOKIE_DOMAIN }

export const types = {
  setPartner: 'SET_PARTNER'
}
export const namespaced = true

const getPartner = () => Cookies.get(partnerDataKey)

export const state = {
  partner: getPartner()
}

export const getters = {
  /**
 * @param state
 * @returns {object}
 */
  partner: state => state.partner
}

export const mutations = {
  /**
 * Define current room
 *
 * @param state
 * @param id
 */
  [types.setPartner] (state, partner) {
    state.partner = partner

    if (partner) {
      Cookies.set(partnerDataKey, state.partner, cookiesOptions)
    }

    if (!partner) {
      Cookies.remove(partnerDataKey, cookiesOptions)
    }
  }
}

export const actions = {
  /**
   * @param commit
   * @param partner
   * @returns {Promise<*>}
   */
  async registerPartner ({ commit }, { partner }) {
    commit(types.setParner, partner)
  }
}
